import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  DashboardData,
  HttpResponse,
  JobInternalConfig,
  UpdateJobCtdReqsRequest,
  UpdateJobInternalConfigRequest,
} from "@/types";

// Sets a job's close-to-the-dollar req count from the dashboard. Optimistic so
// the dropdown and the group's CTD Rev subtotal move together on click.
export function useUpdateSetJobCtdReqs() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      companyId,
      jobId,
      jobInternalConfigId,
      ctdReqs,
    }: UpdateJobCtdReqsRequest) => {
      const path = `companies/${companyId}/jobs/${jobId}/job-internal-configs/${jobInternalConfigId}`;
      await guacHttpClient.patch<
        JobInternalConfig,
        HttpResponse<JobInternalConfig>,
        UpdateJobInternalConfigRequest
      >(path, { ctdReqs });
    },
    onMutate: async ({ jobId, ctdReqs }) => {
      await queryClient.cancelQueries({ queryKey: ["dashboard"] });
      const previousDashboards = queryClient.getQueriesData<DashboardData>({
        queryKey: ["dashboard"],
      });

      queryClient.setQueriesData<DashboardData>(
        { queryKey: ["dashboard"] },
        (data) => {
          if (!data) return data;
          return {
            ...data,
            jobs: data.jobs.map((job) =>
              job.id === jobId ? { ...job, ctdReqs } : job,
            ),
          };
        },
      );

      return { previousDashboards };
    },
  });
}
